import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form, Col, Row, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../../utils/constant";

function AdminModal({ show, handleClose, adminData, fetchAdmins }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    role: "admin",
    date_joined: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (adminData) {
      setFormData({
        first_name: adminData.first_name || "",
        last_name: adminData.last_name || "",
        email: adminData.email || "",
        phone_number: adminData.phone_number || "",
        role: adminData.role || "admin",
        date_joined: adminData.date_joined || "",
      });
    }
  }, [adminData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
      valid = false;
    }

    if (!formData.phone_number.trim()) {
      newErrors.phone_number = "Phone number is required.";
      valid = false;
    } else if (!/^\d{10}$/.test(formData.phone_number)) {
      newErrors.phone_number = "Phone number must be 10 digits.";
      valid = false;
    }

    if (!formData.date_joined.trim()) {
      newErrors.date_joined = "Date joined is required.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      let response;
      const payload = {
        ...formData,
        date_joined: formData.date_joined,
      };

      if (adminData && adminData.id) {
        response = await axios.put(
          `${BASE_URL}/users/tms_users/${adminData.id}/`,
          payload,
          {
            headers: HEADERS,
          }
        );
      } else {
        response = await axios.post(`${BASE_URL}/users/tms_users/`, payload, {
          headers: HEADERS,
        });
      }

      if (response) {
        toast.success(
          `Admin ${
            adminData && adminData.id ? "updated" : "added"
          } successfully!`
        );
        fetchAdmins();
        handleClose();
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } 
      } 
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {adminData && adminData.id ? "Edit Admin" : "Add Admin"}
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleFormSubmit}>
        <Modal.Body>
          <Row className="mb-4">
            <Col md={6}>
              <Form.Control
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleInputChange}
                placeholder="First Name*"
                required
              />
            </Col>
            <Col md={6}>
              <Form.Control
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleInputChange}
                placeholder="Last Name"
                // required
              />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md={6}>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email*"
                required
                // disabled={!!adminData}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Col>
            <Col md={6}>
              <Form.Control
                type="text"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleInputChange}
                placeholder="Phone Number*"
                required
                // disabled={!!adminData}
                isInvalid={!!errors.phone_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.phone_number}
              </Form.Control.Feedback>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md={6}>
              <Form.Control
                type="date"
                name="date_joined"
                value={formData.date_joined}
                onChange={handleInputChange}
                required
                isInvalid={!!errors.date_joined}
              />
              <Form.Control.Feedback type="invalid">
                {errors.date_joined}
              </Form.Control.Feedback>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Close
          </Button>

          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
              </>
            ) : adminData ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default AdminModal;
